import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-4 px-3 py-2" }
const _hoisted_2 = { class: "mt-4" }

import { ref, watch } from 'vue'
import { BaseInput } from '@/components'

interface Props {
  modelValue: string
  periodOptions: { value: string; label: string }[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PeriodSelector',
  props: {
    modelValue: {},
    periodOptions: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const selectedPeriod = ref(props.modelValue)

const handlePeriodChange = (value: string) => {
  emit('update:modelValue', value)
}

watch(() => props.modelValue, (newValue) => {
  selectedPeriod.value = newValue
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
      _createElementVNode("i", { class: "fas fa-calendar-alt text-black text-sm" }),
      _createElementVNode("label", { class: "text-sm font-medium text-black pt-2" }, "Période :")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseInput), {
        modelValue: selectedPeriod.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedPeriod).value = $event)),
          handlePeriodChange
        ],
        type: "select",
        options: _ctx.periodOptions
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}
}

})